import React from 'react';

export type SpinnerSize = 'small' | 'medium' | 'large';

interface LoadingSpinnerProps {
  size?: SpinnerSize;
  text?: string;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, { spinner: string; text: string }> = {
  small: {
    spinner: 'w-4 h-4 border-2',
    text: 'text-sm',
  },
  medium: {
    spinner: 'w-8 h-8 border-3',
    text: 'text-base',
  },
  large: {
    spinner: 'w-12 h-12 border-4',
    text: 'text-lg',
  },
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  text,
  className = '',
}) => {
  const { spinner: spinnerClass, text: textClass } = sizeClasses[size];

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`${spinnerClass} border-gray-200 border-t-indigo-600 rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      />
      {text && (
        <p className={`mt-3 ${textClass} text-gray-600 animate-pulse`}>
          {text}
        </p>
      )}
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;